import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import './ReactionBar.scss';
import { CommunityContext } from '../../../contexts/ContextCreator';
import CommunityLikeButton from './CommunityLikeButton/CommunityLikeButton';
import CommunityCommentButton from './CommunityCommentButton/CommunityCommentButton';
import CommunityShareButton from './CommunityShareButton/CommunityShareButton';

const ReactionBar = ({
    hash,
    expandCommentCallback,
    location,
    redirectToPage,
    className,
    showLikeLabel,
    showShareLabel,
}) => {
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const isComment = content?.type === 'community-comment';
    const showCommentIcon = isComment ? true : content?.canComment;
    const replyReactionBarStyling = isComment ? 'reply-styling' : '';

    return (
        <div
            className={`component-Community-ReactionBar ${replyReactionBarStyling} ${className}`}
        >
            <CommunityLikeButton hash={hash} showLabel={showLikeLabel} />
            {showCommentIcon ? (
                <CommunityCommentButton
                    hash={hash}
                    expandCommentCallback={expandCommentCallback}
                    location={location}
                    redirectToPage={redirectToPage}
                />
            ) : null}
            {!isComment ? (
                <CommunityShareButton
                    hash={hash}
                    location={location}
                    showLabel={showShareLabel}
                />
            ) : null}
        </div>
    );
};

ReactionBar.propTypes = {
    hash: PropTypes.string.isRequired,
    /**
     * Function to exapand comment -> should only be used in Commen Components
     */
    expandCommentCallback: PropTypes.func,
    /**
     * component location, mostly needed for the case of contributions.
     */
    location: PropTypes.oneOf([
        'masterFeed',
        'miniFeed',
        'groupFeed',
        'singleContent',
        'contributions',
    ]),
    redirectToPage: PropTypes.bool,
    /**
     * Optional styles for this component
     */
    className: PropTypes.string,
    /**
     * Show label on Like button
     */
    showLikeLabel: PropTypes.bool,
    /**
     * Show label on Share button
     */
    showShareLabel: PropTypes.bool,
};

ReactionBar.defaultProps = {
    expandCommentCallback: null,
    location: 'masterFeed',
    redirectToPage: false,
    className: '',
    showLikeLabel: true,
    showShareLabel: true,
};

ReactionBar.displayName = 'ReactionBar';

export default React.memo(ReactionBar);
